import React from 'react';

const Loading = () => (
  <div style={{textAlign:'center',marginTop:'1rem'}}>
    Loading...
  </div>
)

export default Loading;
